/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import Layout from '../../Components/Layout';
import SettingsLayout from './SettingsLayout';
import { closePanel, openPanel } from '../../Redux/Panels/RightPanel/actions';
import { loggedUser } from '../../Constants/menus';
import Api from '../../Server/Api';
import { SpecialistServices } from './RidersDocument';
import { FormContent } from '../../Components/FormContent';

const api = new Api();

const structure = [
	{
		title: "My Categories",
		description: "Enter personal information and login details.",
		// sectionClass: "mt-5 pt-5 border-top top-border",
		fields: [
			{
				name: "categories",
				label: "Categories",
				type: "categories_tags"
			},
		]
	}
];

const ServiceProfile = (props) => {
    const readOnly = false;
	let PROFILE = props?.user?.user || {};
	
	const [DATA, setDATA] = React.useState({});
	
	
	const updateProfile = (d) => {
		setDATA({...DATA, ...d})
	}

	React.useEffect(() => {
		setDATA({ category: (PROFILE.categories || []).map((e) => { return e.id })})
	}, [PROFILE.categories])


	const saveCategories = async (id) => {
		await api.put({ endpoint: `/users/${loggedUser?.username}/add_category/`, data: { id: id } })
	}
    
    return (
        <Layout sidePanel={true} title={"Account Profile"}>
            <SettingsLayout
                title={"Categories & Services"}
				data={DATA}
				endPoint={`users/${PROFILE?.username}/`}
				disableSaving
            >
                	<div className="form-body p-5" style={{ paddingTop: "0px !important" }}>

					<FormContent
						{...props} 
						structure={structure} 
						selectedCategories={DATA?.category||[]}
						updateProfile={updateProfile} PROFILE={PROFILE} 
						saveCategories={saveCategories}
					/>
					
					<div className="form-fieldset">
						<div className="columns is-multiline">
							<div className="column is-12">
								<SpecialistServices
									value={props?.riderform?.documents}
									callback={(e) => updateRider({ documents: e })}
									remove={(e) => removeImage(e)}
									readOnly={props?.readOnly}
									services={PROFILE.services}
								/>
							</div>
						</div>
					</div>
					
					
				</div>
            </SettingsLayout>
        </Layout>
    )
}

const mapStateToProps = ({ user, categories }) => {
	return { user, categories: categories?.allcategories || [] };
};

const mapDispatchToProps = (dispatch) => {
	return {
		// updateSettings: (e) => dispatch(updateSettings(e)),
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
		
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceProfile);
